import { type IAssuranceLevel } from '../model';

type Props = {
  level: IAssuranceLevel;
};

const AssuranceLevelRow = ({ level: { label, description, icon: Icon } }: Props) => (
  <li aria-label={label} className="flex items-start gap-3 rounded-lg bg-muted px-4 py-3">
    <Icon aria-hidden="true" className="mt-0.5 size-6 shrink-0" />
    <div className="min-w-0 grow space-y-px">
      <div className="text-sm font-bold text-foreground">{label}</div>
      <p className="text-xs leading-[1.4] text-muted-foreground">{description}</p>
    </div>
  </li>
);

export default AssuranceLevelRow;
